import React from 'react';
import { StyleSheet } from 'react-native';
import { Badge as RNPBadge } from 'react-native-paper';

import { usePaperTheme } from '@context/ThemeContext';

export type BadgeProps = React.ComponentProps<typeof RNPBadge>;

export default function Badge(props: BadgeProps) {
  return <RNPBadge {...props} />;
}

export function AccentBadge({ style, ...props }: BadgeProps) {
  const paperTheme = usePaperTheme();

  const dynamicStyles = StyleSheet.create({
    badge: {
      backgroundColor: paperTheme.colors.accent,
    },
  });
  return <RNPBadge style={[dynamicStyles.badge, style]} {...props} />;
}
